import React from 'react';
import './Input.css';
import {TiArrowMaximise} from 'react-icons/ti';
import {DiHtml53DEffects} from 'react-icons/di';
import {IconContext} from 'react-icons';


export default class Input extends React.Component{
    constructor(props){
        super(props);
        this.state = {
              classTop: "top-input",
              classText: "text-input",
              status: false,
              
        }
        this.handleMaximise = this.handleMaximise.bind(this);
    }

    handleMaximise(){
        this.setState(state => ({
                                 status: !state.status,
                                 classTop: state.status ? "top-input" : "top-input-max",
                                 classText: state.status ? "text-input" : "text-input-max"            
                                }))
    }

    render(){
    return (
            <div className="Input">
                <div className={this.state.classTop}>
                     <div className="logo-input">
                     <IconContext.Provider value={{className: "html-input"}}>
                          <DiHtml53DEffects />
                     </IconContext.Provider>
                     </div>
                     <div className="title-input">HTML Markdown - Type here your Markup/Markdown code</div>
                     <div  className="resize-input" onClick={this.handleMaximise}>
                     <IconContext.Provider value={{className: "maximise-input"}}>
                          <TiArrowMaximise />
                     </IconContext.Provider>
                     </div>
                </div>
                <textarea id="editor" value={this.props.input} onChange={this.props.change} className={this.state.classText}></textarea>
                      
            </div> 
            )
    }
    }
